<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <v-container class="pb-0">
    <v-container
      class="flex-message-box pa-0 ma-0 mb-2"
      v-for="(msg, index) in messages"
      :key="index"
      :class="{ operator: msg.respondent == 'support' }"
    >
      <v-container class="wrapper-message-box pa-0 ma-0">
        <div class="d-flex justify-space-between gap-5 mb-4">
          <v-card-text class="text-caption pa-0"
            >{{ msg.user ? msg.user.firstname : "-" }}
            {{ msg.user ? msg.user.lastname : "-" }}</v-card-text
          >
        </div>
        <!-- <v-card-text
                    class="text-body-1 pa-0 rendered-message"
                    style="line-height: 26px;"
                    v-html="decodeURIComponent(msg.message)"
                >
                </v-card-text> -->
        <v-card-text
          class="text-body-1 pa-0 rendered-message"
          style="line-height: 26px"
          v-html="formattedMessage(msg.message)"
        >
        </v-card-text>
        <v-container v-if="msg.files.length > 0" class="pa-0">
          <!--image-->
          <div
            class="d-flex align-center mt-3"
            style="flex-wrap: wrap; column-gap: 0.5rem"
          >
            <div
              v-for="(file, index) in msg.files"
              :key="index"
              v-if="resolveImgExtension(file)"
            >
              <a :href="file.link" target="_blank">
                <img :src="file.link" class="attached-img" />
              </a>
            </div>
          </div>
          <!--document-->
          <div
            v-for="(file, index) in msg.files"
            :key="index"
            v-if="resolveDocExtension(file)"
            class="d-flex align-center gap-2 my-4"
          >
            <a
              :href="file.link"
              target="_blank"
              class="d-flex align-center gap-2 grey--text text--darken-2"
            >
              <img :src="resolveDocImg(file)" class="attached-file" />
              <v-card-text class="text-body-2 pa-0">
                {{ file.title ? file.title : "file" }} {{ file.extension }}
              </v-card-text>
            </a>
          </div>
        </v-container>
      </v-container>
      <v-card-text class="text-caption pa-0 mb-1" style="width: auto">{{
        msg.time
      }}</v-card-text>
    </v-container>
  </v-container>
</template>

<script>
import imageXlsx from "@/assets/ticket/xlsx.png";

export default {
  props: {
    messages: Array,
  },
  data() {
    return {};
  },
  methods: {
    resolveImgExtension(file) {
      if (
        file.extension === ".png" ||
        file.extension === ".jpg" ||
        file.extension === ".jpeg" ||
        file.extension === ".gif" ||
        file.extension === ".webp"
      ) {
        return "true";
      }
    },
    resolveDocExtension(file) {
      if (
        file.extension === ".pdf" ||
        file.extension === ".doc" ||
        file.extension === ".docx" ||
        file.extension === ".txt" ||
        file.extension === ".xlsx" ||
        file.extension === ".pptx"
      ) {
        return "true";
      }
    },
    resolveDocImg(file) {
      if (file.extension === ".pdf") {
        return "https://cdn-icons-png.flaticon.com/512/11180/11180756.png";
      }
      if (file.extension === ".xlsx") {
        return imageXlsx;
      }
    },
    formattedMessage(message) {
      // Ensure message is a string before using .replace()
      if (typeof message !== "string") {
        return message; // If not a string, just return as is (or return an empty string if needed)
      }

      // Regex to find URLs starting with http, https or /
      const urlRegex = /((https?:\/\/[^\s]+)|\/[^\s]+)/g;

      // Replace URLs with <a> tags and decode them
      return message.replace(urlRegex, (match) => {
        // Decode each URL to handle Persian or other special characters
        const decodedUrl = decodeURIComponent(match);
        return `<a href="${decodedUrl}" target="_blank" class="link-style">${decodedUrl}</a>`;
      });
    },
  },
  watch: {},
};
</script>

<style scoped>
.flex-message-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.flex-message-box.operator {
  align-items: flex-end;
}
.flex-message-box .wrapper-message-box {
  min-width: 160px !important;
  max-width: 72% !important;
  width: max-content;
  padding: 10px 14px 12px !important;
  border-radius: 4px;
  border: 1px solid #e6eaf0;
  background-color: #fff;
  color: #0f172a;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.flex-message-box .wrapper-message-box > .d-flex {
  margin-bottom: 6px !important;
}
.flex-message-box .wrapper-message-box > .d-flex .text-caption {
  font-weight: 700;
  color: #0066ff;
}
.flex-message-box.operator .wrapper-message-box {
  background-color: #0066ff;
  border-color: #0066ff;
  color: #fff;
}
.flex-message-box.operator .wrapper-message-box > .d-flex .text-caption {
  color: rgba(255, 255, 255, 0.85);
}
.flex-message-box .wrapper-message-box .rendered-message {
  white-space: pre-wrap;
  color: inherit !important;
  font-size: 13px !important;
  line-height: 1.85 !important;
}
.flex-message-box > .text-caption {
  color: #94a3b8;
  font-size: 11px !important;
  padding: 0 4px !important;
}
.flex-message-box .wrapper-message-box .attached-img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background-color: #fff;
}
.flex-message-box .wrapper-message-box .attached-file {
  width: 32px;
  height: 32px;
}
.flex-message-box .wrapper-message-box a.d-flex {
  padding: 6px 10px;
  border-radius: 4px;
  background: rgba(15, 23, 42, 0.04);
  text-decoration: none;
}
.flex-message-box.operator .wrapper-message-box a.d-flex {
  background: rgba(255, 255, 255, 0.16);
  color: #fff !important;
}
.flex-message-box.operator .wrapper-message-box a.d-flex .v-card__text {
  color: #fff !important;
}
.flex-message-box .wrapper-message-box .rendered-message ::v-deep .link-style {
  cursor: pointer;
  color: #0066ff;
  text-decoration: underline !important;
  word-break: break-all;
}
.flex-message-box.operator .wrapper-message-box .rendered-message ::v-deep .link-style {
  color: #fff;
}
@media (max-width: 959px) {
  .flex-message-box .wrapper-message-box {
    max-width: 88% !important;
    min-width: 120px !important;
  }
}
/* dark mode */
.theme--dark .flex-message-box .wrapper-message-box {
  background-color: #262626;
  border-color: #333;
  color: #eee;
}
.theme--dark .flex-message-box.operator .wrapper-message-box {
  background-color: #0050c8;
  border-color: #0050c8;
}
.theme--dark .flex-message-box .wrapper-message-box .attached-img {
  background-color: #262626;
  border-color: #444;
}
</style>
